import { ca } from '@cian/analytics';

const getBannerLocation = (totalPages: number) => {
  return totalPages > 1 ? 'after_pagination' : 'infinite';
};

export const trackOpenSmsPopup = (ishomeowner: boolean, totalPages: number) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Open',
    label: 'SMS',
    banner_location: getBannerLocation(totalPages),
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackVerifyPhone = (ishomeowner: boolean, totalPages: number) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_confirm',
    label: 'SMS',
    banner_location: getBannerLocation(totalPages),
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackPhoneVerificationSuccess = (ishomeowner: boolean, totalPages: number) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'SMS',
    banner_location: getBannerLocation(totalPages),
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackSendFormSuccess = (ishomeowner: boolean, totalPages: number) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'Page',
    banner_location: getBannerLocation(totalPages),
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackVerificationPhoneError = (ishomeowner: boolean, totalPages: number) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Wrong_code',
    label: 'SMS',
    banner_location: getBannerLocation(totalPages),
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};
